import { render, staticRenderFns } from "./fromMaterial.vue?vue&type=template&id=5cece8cc&scoped=true&"
import script from "./fromMaterial.vue?vue&type=script&lang=js&"
export * from "./fromMaterial.vue?vue&type=script&lang=js&"
import style0 from "./fromMaterial.vue?vue&type=style&index=0&id=5cece8cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cece8cc",
  null
  
)

export default component.exports